import { getNestedPages } from '@pm2/api';
import { fetchPageDescriptorByPath } from './util.fetch-page-descriptor-by-path.js';
import { findPageDescriptorByPath } from './util.find-page-descriptor-by-path.js';

function getPageDescriptorByPath(configStore, sitemapStore, path) {
  var _a;
  if (!path) {
    return void 0;
  }
  const pageDescriptor = findPageDescriptorByPath(
    sitemapStore.getState(),
    path
  );
  if (pageDescriptor) {
    if (!pageDescriptor.children && pageDescriptor.hasChildren) {
      const configState = configStore.getState();
      return Promise.resolve(
        getNestedPages(configState.config, pageDescriptor.id, {
          levels: pageDescriptor.type === "Course" ? 2 : 1,
          previewMode: configState.previewMode
        })
      ).then((children) => {
        sitemapStore.dispatch(
          sitemapStore.actions.updatePageDescriptor({
            ...pageDescriptor,
            children
          })
        );
        return {
          ...pageDescriptor,
          children
        };
      });
    }
    return pageDescriptor;
  }
  if ((_a = sitemapStore.getState().notFoundPaths) == null ? void 0 : _a.includes(path)) {
    return;
  }
  return fetchPageDescriptorByPath(configStore, sitemapStore, path);
}

export { getPageDescriptorByPath };
//# sourceMappingURL=util.get-page-descriptor-by-path.js.map
